import React from 'react';
import Footer from '../component/Footer';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap is included

const Kidney = () => {
  return (
    <>
      <div className="container my-5">
        <h1 className="text-center mb-4">Kidney Transplant</h1>
        
        <section className="mb-4">
          <h2>What is a Kidney Transplant?</h2>
          <p className="text-justify">
            A kidney transplant is a surgical procedure where a healthy kidney from a donor is implanted into 
            a patient whose kidneys are no longer functioning properly. This procedure offers an alternative to 
            long-term dialysis and improves both the quality of life and life expectancy for individuals with severe kidney disease.
          </p>
        </section>

        <section className="mb-4">
          <h2>Who Needs a Kidney Transplant?</h2>
          <p className="text-justify">
            A kidney transplant is recommended for patients with end-stage renal disease (ESRD), where the kidneys 
            lose the ability to filter waste from the blood. Some conditions that lead to ESRD include:
          </p>
          <ul>
            <li><strong>Chronic Kidney Disease (CKD):</strong> Progressive loss of kidney function over time.</li>
            <li><strong>Diabetes:</strong> Leading to diabetic nephropathy, a major cause of kidney failure.</li>
            <li><strong>Hypertension (High Blood Pressure):</strong> Causing damage to the kidneys over time.</li>
            <li><strong>Glomerulonephritis:</strong> Inflammation of the kidney's filtering units.</li>
            <li><strong>Polycystic Kidney Disease (PKD):</strong> A genetic disorder causing cysts in the kidneys.</li>
          </ul>
          <p className="text-justify">
            For patients with ESRD, a kidney transplant can offer greater freedom, improved energy levels, and better 
            health compared to dialysis.
          </p>
        </section>

        <section className="mb-4">
          <h2>Deceased Donor Kidney Transplant</h2>
          <p className="text-justify">
            A deceased donor kidney transplant involves receiving a kidney from an individual who has passed away. These 
            organs typically come from people who have consented to donate their organs before death, either through an 
            organ donor card or by their family’s consent at the time of death. The kidney is then transplanted into a 
            recipient whose own kidneys have failed.
          </p>
        </section>

        <section className="mb-4">
          <h2>Living Donor Kidney Transplant</h2>
          <p className="text-justify">
            A living donor kidney transplant involves the donation of a kidney from a healthy person, often a family member, 
            spouse, or friend, but it can also come from altruistic donors (Good Samaritans). This type of transplant offers 
            several advantages over a deceased donor transplant:
          </p>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default Kidney;
